import { c as _c } from "react/compiler-runtime";
import { CURRENCY_PREFERENCE_COOKIE_NAME, useCurrency, useRouter } from "@opensea/navigation";
import Cookies from "js-cookie";
import { LONG_LASTING_COOKIE_EXPIRATION } from "@/lib/cookie";
import { trackAction } from "@/lib/integrations/datadog";
export function useCurrencySwitch() {
  const $ = _c(9);
  const {
    currency
  } = useCurrency();
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = function setPersistedCurrency(nextCurrency) {
      Cookies.set(CURRENCY_PREFERENCE_COOKIE_NAME, nextCurrency, {
        expires: LONG_LASTING_COOKIE_EXPIRATION
      });
      trackAction("switch currency", {
        value: nextCurrency
      });
      router.refresh();
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setPersistedCurrency = t0;
  let t1;
  if ($[2] !== currency || $[3] !== setPersistedCurrency) {
    t1 = function toggleCurrency() {
      const nextCurrency_0 = currency === "crypto" ? "usd" : "crypto";
      setPersistedCurrency(nextCurrency_0);
    };
    $[2] = currency;
    $[3] = setPersistedCurrency;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const toggleCurrency = t1;
  let t2;
  if ($[5] !== currency || $[6] !== setPersistedCurrency || $[7] !== toggleCurrency) {
    t2 = {
      currency,
      setCurrency: setPersistedCurrency,
      toggleCurrency
    };
    $[5] = currency;
    $[6] = setPersistedCurrency;
    $[7] = toggleCurrency;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}